<template>
  <div class="employee-invite">
    <el-button type="success" @click="invitation = true" size="medium">邀请加入</el-button>

    <!-- 邀请加入的对话框 -->
    <Modal v-model="invitation" title="邀请新成员加入" :mask-closable="false" footer-hide>
      <h3>通过分享二维码邀请员工加入团队</h3>
      <div class="shareText">
        <div class="box">
          二维码有效时长
          <InputNumber :max="24" :min="1" :style="{width:'60px'}" v-model="qrDuration" size="small"></InputNumber>小时
          <Button class="createQr" type="primary" shape="circle" @click="createQrcode">生成二维码</Button>
        </div>

        <p>说明：有效期默认24小时，最小1小时</p>
      </div>
    </Modal>

    <Modal v-model="qrStatus" title="邀请新成员加入" :mask-closable="false" footer-hide>
      <qr-code :qrSrc="qrCodeSrc"></qr-code>
    </Modal>
  </div>
</template>

<script>
import qrcode from "@/components/qrcode/qrcode.vue";

export default {
  components: {
    "qr-code": qrcode
  },
  data() {
    return {
      invitation: false,

      qrDuration: 24,

      qrStatus: false,

      qrCodeSrc: ""
    };
  },

  methods: {
    createQrcode() {
      var params = {
        duration: this.qrDuration
      };
      this.$api.qrCode(params).then(data => {
        this.qrCodeSrc = data;
        this.qrStatus = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button {
  padding: 12px 20px;
}
</style>